import {Modal} from 'bootstrap';
import flatpickr from "flatpickr";
class CustomModal {
    constructor() {
        this.modalSuperiorityTriggers = document.querySelectorAll(".modalSuperiorityTrigger")
        this.modalRegisterTriggers = document.querySelectorAll(".modalRegisterTrigger")
    }
    events(){
        for (const modalSuperiorityTrigger of this.modalSuperiorityTriggers) {
            modalSuperiorityTrigger.addEventListener('click', (event) => {
                event.preventDefault();
                let modalImage=modalSuperiorityTrigger.dataset.image;
                let modalTitle=modalSuperiorityTrigger.dataset.title;
                let modalContent=modalSuperiorityTrigger.dataset.content;
                let dataModal={
                    modalImage:modalImage,
                    modalTitle:modalTitle,
                    modalContent:modalContent
                }
                this.loadModalSuperiority(dataModal)
            })
        }
        for (const modalRegisterTrigger of this.modalRegisterTriggers) {
            modalRegisterTrigger.addEventListener('click', (event) => {
                event.preventDefault();
                this.loadModalRegister()
            })
        }
    } 
    loadModalSuperiority(dataModal){
        const modalSuperiorityImage=document.querySelector('#modalSuperiorityImage');
        const modalSuperiorityTitle=document.querySelector('#modalSuperiorityTitle');
        const modalSuperiorityContent=document.querySelector('#modalSuperiorityContent');
        modalSuperiorityImage.src=dataModal.modalImage;
        modalSuperiorityTitle.innerHTML=dataModal.modalTitle
        modalSuperiorityContent.innerHTML=dataModal.modalContent

        const modalSuperiority = new Modal('#superiorityModal', {
            keyboard: false
        });

        modalSuperiority.show();
    }
    loadModalRegister(){
        const modalRegister = new Modal('#registerModal', {
            keyboard: false
        });
        let currentDate = new Date();
        let minDate=this.decrYears(currentDate, 21).getFullYear().toString();
        let maxDate=this.decrYears(currentDate, 11).getFullYear().toString();
        maxDate=maxDate+"-12";
        modalRegister.show();
        flatpickr("#bod", {
            dateFormat: "Y/m/d",
            //minDate: minDate,
            // maxDate: maxDate,
            defaultDate: "2000/01/01"
        });
    }

    decrYears(date, years) {
        let newDate = new Date(date.valueOf());
        newDate.setFullYear(newDate.getFullYear() - years);
        return newDate;
    }
}
export default CustomModal